(function(){
  'use strict';

  function parseJsonNode(root,selector){
    var el=root.querySelector(selector);
    if(!el) el=document.querySelector(selector);
    if(!el) return null;
    var text=(el.textContent||'').trim();
    if(!text||text==='null') return null;
    try{
      var value=JSON.parse(text);
      if(typeof value==='string') value=JSON.parse(value);
      return value;
    }catch(e){return null;}
  }

  function normalizeFeed(feed){
    var rows=feed&&Array.isArray(feed.reviews)?feed.reviews:[];
    return rows.map(function(x){
      return {
        id:String((x&&x.id)||''),
        r:Number((x&&x.rating)||0),
        n:String((x&&x.author)||'Client NAO CASE'),
        t:String((x&&x.review)||''),
        d:String((x&&x.date)||'').slice(0,10),
        v:x&&x.verified===true?1:0,
        x:x&&x.incentivized===true?1:0
      };
    }).filter(function(x){return x.r>=1&&x.r<=5&&x.t;});
  }

  function formatDate(iso){
    if(!iso) return '';
    try{return new Intl.DateTimeFormat('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric'}).format(new Date(iso+'T12:00:00Z'));}
    catch(e){return iso;}
  }

  function setSummary(root,mode){
    var isProduct=mode==='product';
    var score=Number(root.getAttribute(isProduct?'data-product-score':'data-store-score')||0);
    var total=Number(root.getAttribute(isProduct?'data-product-count':'data-store-count')||0);
    var scoreEl=root.querySelector('[data-summary-score]');
    var stars=root.querySelector('[data-summary-stars]');
    var based=root.querySelector('[data-summary-based]');
    var verified=root.querySelector('[data-summary-verified]');
    if(scoreEl) scoreEl.textContent=(score||0).toFixed(1);
    if(stars) stars.style.setProperty('--nao-rating-pct',(Math.max(0,Math.min(5,score))*20)+'%');
    if(based) based.textContent='Basé sur '+total+' avis';
    if(verified) verified.textContent='Avis clients vérifiés';
  }

  function card(item){
    var article=document.createElement('article');article.className='nao-review-card';
    var top=document.createElement('div');top.className='nao-review-card__top';
    var identity=document.createElement('div');identity.className='nao-review-card__identity';
    var name=document.createElement('div');name.className='nao-review-card__name';
    var nt=document.createElement('span');nt.textContent=item.n||'Client NAO CASE';name.appendChild(nt);

    if(Number(item.v)===1){
      var ver=document.createElement('span');ver.className='nao-review-card__verified';
      var dot=document.createElement('span');dot.className='nao-review-card__verified-dot';dot.textContent='✓';
      ver.appendChild(dot);ver.appendChild(document.createTextNode('Achat vérifié'));name.appendChild(ver);
    }
    if(Number(item.x)===1){
      var inc=document.createElement('span');inc.className='nao-review-card__incentive';inc.textContent='Avis récompensé';name.appendChild(inc);
    }

    var date=document.createElement('div');date.className='nao-review-card__date';date.textContent=formatDate(item.d);
    identity.appendChild(name);identity.appendChild(date);

    var stars=document.createElement('div');stars.className='nao-review-card__stars';
    stars.setAttribute('aria-label',String(item.r||0)+' sur 5');
    stars.textContent='★★★★★'.slice(0,Math.max(0,Math.min(5,Number(item.r)||0)));
    top.appendChild(identity);top.appendChild(stars);

    var text=document.createElement('p');text.className='nao-review-card__text';text.textContent=item.t||'';
    article.appendChild(top);article.appendChild(text);
    if((item.t||'').length>180){
      text.classList.add('is-collapsible');
      var toggle=document.createElement('button');
      toggle.type='button';
      toggle.className='nao-review-card__toggle';
      toggle.textContent='Lire la suite';
      toggle.setAttribute('aria-expanded','false');
      toggle.addEventListener('click',function(){
        var expanded=text.classList.toggle('is-expanded');
        toggle.textContent=expanded?'Réduire':'Lire la suite';
        toggle.setAttribute('aria-expanded',expanded?'true':'false');
      });
      article.appendChild(toggle);
    }
    return article;
  }

  function init(root){
    var productCount=Number(root.getAttribute('data-product-count')||0);
    var list=root.querySelector('[data-review-list]');
    var loadMore=root.querySelector('[data-review-loadmore]');
    var tabs=[].slice.call(root.querySelectorAll('[data-review-tab]'));
    var productRows=normalizeFeed(parseJsonNode(root,'[data-nao-product-feed]'));
    var storeRows=normalizeFeed(parseJsonNode(root,'[data-nao-store-feed]'));
    var mode=productCount>0?'product':'store';
    var page=1,pageSize=8;

    function activeTab(){
      tabs.forEach(function(btn){
        var on=btn.getAttribute('data-review-tab')===mode;
        btn.classList.toggle('is-active',on);
        btn.setAttribute('aria-selected',on?'true':'false');
      });
    }

    function rawRows(){return mode==='product'?productRows:storeRows;}

    function rowsForDisplay(){
      var arr=rawRows().slice();
      arr.sort(function(a,b){return String(b.d).localeCompare(String(a.d));});
      return arr;
    }

    function render(){
      var source=rawRows();
      var arr=rowsForDisplay();
      var visible=arr.slice(0,page*pageSize);
      list.innerHTML='';

      if(!source.length){
        var empty=document.createElement('div');empty.className='nao-reviews-empty';
        var box=document.createElement('div');
        var strong=document.createElement('strong');
        var span=document.createElement('span');
        strong.textContent=mode==='product'?'Les avis de ce produit se synchronisent.':'Les avis boutique se synchronisent.';
        span.textContent=mode==='product'?'Tu peux consulter les avis sur la boutique en attendant.':'Réessaie dans quelques instants.';
        box.appendChild(strong);box.appendChild(span);empty.appendChild(box);list.appendChild(empty);
      }else{
        visible.forEach(function(x){list.appendChild(card(x));});
      }

      if(loadMore) loadMore.classList.toggle('is-visible',visible.length<arr.length);
      setSummary(root,mode);
    }

    tabs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var next=btn.getAttribute('data-review-tab');
        if(next===mode)return;
        mode=next;page=1;activeTab();render();
      });
    });
    if(loadMore) loadMore.addEventListener('click',function(){page++;render();});

    var dialog=root.querySelector('[data-review-dialog]');
    var open=root.querySelector('[data-review-open]');
    var close=root.querySelector('[data-review-close]');
    if(open&&dialog) open.addEventListener('click',function(){if(dialog.showModal)dialog.showModal();else dialog.setAttribute('open','');});
    if(close&&dialog) close.addEventListener('click',function(){if(dialog.close)dialog.close();else dialog.removeAttribute('open');});
    if(dialog) dialog.addEventListener('click',function(e){if(e.target===dialog){if(dialog.close)dialog.close();else dialog.removeAttribute('open');}});
    if(dialog&&dialog.querySelector('.nao-review-form__success')&&dialog.showModal){try{dialog.showModal();}catch(e){}}

    activeTab();
    render();
  }

  function boot(){document.querySelectorAll('[data-nao-reviews-system]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
